<template>
    <span :style="titleStyles" :class="titleClasses">
      <span>{{ hreflessTitle }}</span>
      <feather-icon v-if="taskHref" icon="LinkIcon" class="hover:text-warning cursor-pointer external-icon" svgClasses="h-4 w-4" @click.stop="openHref"/>
      <slot></slot>
    </span>
</template>
<script>

const urlRegex = /(https?:\/\/[^ ]*)/
export default {
  components: {
  },
  props: ['title', 'titleClasses', 'titleStyles'],
  computed: {
    hreflessTitle () {
      if (this.taskHref) {
        return this.title.replace(this.taskHref, '')
      } else {
        return this.title
      }
    },
    taskHref () {
      const match = this.title.match(urlRegex)
      if (match) {
        return match[1]
      } else {
        return ''
      }
    },
  },
  methods: {
    openHref () {
      window.open(this.taskHref, '_blank')
    },
  }
}
</script>
